import React, { useEffect, useState } from 'react'
import Breadcrumb from '../components/Breadcrumb'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ContactCTA from '../components/ContactCTA'
import CapabilitiesSlider from '../components/CapabilitiesSlider'
import OurJourney from '../components/OurJourney'
import WhyChoose from '../components/WhyChoose'
import MissionVision from '../components/MissionVision'
import BASE_URL from '../BASEURL'

const About = () => {
  const [hero, setHero] = useState({
    title: '',
    description_1: '',
    description_2: '',
    description_3: '',
    image: '',
  })

  useEffect(() => {
    const load = async () => {
      try { 
        const res = await fetch(`${BASE_URL}/api/as`)
        if (!res.ok) return
        const json = await res.json()
        const payload = (json && Array.isArray(json.data) && json.data.length) ? json.data[0] : json
        setHero(prev => ({
          title: payload.title || prev.title,
          description_1: payload.description_1 || payload.description1 || prev.description_1,
          description_2: payload.description_2 || payload.description2 || prev.description_2,
          description_3: payload.description_3 || payload.description3 || prev.description_3,
          image: payload.image || prev.image,
        }))
      } catch (err) {
        console.error('Failed to load about hero:', err)
      }
    }

    load()
  }, [])

  return (
    <>
      <Navbar />

      <div className='bg-dark'>
        <Breadcrumb />
      </div>

      {/* ABOUT INTRO */}
      <section className="py-8">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}
          <div data-aos="fade-up">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-primary">
              {hero.title}
            </h1>

            <p className="mt-6 text-gray-600 font-body leading-relaxed">
              {hero.description_1}
            </p>

            <p className="mt-4 text-gray-600 font-body leading-relaxed">
              {hero.description_2}
            </p>

            <p className="mt-4 text-gray-600 font-body leading-relaxed">
              {hero.description_3}
            </p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="rounded-xl overflow-hidden shadow-lg" data-aos="fade-up">
            {hero.image && (
              <img
                src={hero.image}
                alt="Sera Water - Water Treatment Equipment Supplier in Ahmedabad"
                className="w-full h-full object-cover"
              />
            )}
          </div>

        </div>
      </section>

     <MissionVision />

      <WhyChoose />



      <OurJourney />

      <CapabilitiesSlider />


      {/* CONTACT CTA */}
      <ContactCTA />



      <Footer />

    </>
  )
}

export default About